var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-form",
        {
          ref: "form",
          staticClass: "ticket-access-form",
          model: {
            value: _vm.valid,
            callback: function($$v) {
              _vm.valid = $$v
            },
            expression: "valid"
          }
        },
        [
          _c(
            "v-stepper",
            {
              attrs: { vertical: "", "non-linear": "" },
              model: {
                value: _vm.currentStep,
                callback: function($$v) {
                  _vm.currentStep = $$v
                },
                expression: "currentStep"
              }
            },
            [
              _c(
                "v-stepper-step",
                {
                  class: {
                    "current-step": _vm.currentStep == 1,
                    "next-step": _vm.highestStepReached < 1,
                    "previous-step": _vm.highestStepReached > 1
                  },
                  attrs: {
                    "edit-icon": "mdi-ticket-confirmation-outline",
                    "complete-icon": "mdi-ticket-confirmation-outline",
                    complete: "",
                    editable: _vm.highestStepReached >= 1,
                    step: "1"
                  }
                },
                [
                  _vm._v(" Información General "),
                  _c("small", [
                    _vm._v(
                      " En esta sección podrás especificar los detalles de tu requerimiento. "
                    )
                  ])
                ]
              ),
              _c(
                "v-stepper-content",
                { attrs: { step: "1" } },
                [
                  _c("TicketGeneralInformation", {
                    ref: "Step1",
                    attrs: { formValues: _vm.formValues },
                    on: {
                      getTapeManagementTypingSelected:
                        _vm.getTapeManagementTypingSelected,
                      nextStep: _vm.nextStep,
                      previousStep: _vm.previousStep,
                      enableTapeStep: _vm.enableTapeStep
                    }
                  })
                ],
                1
              ),
              _vm.requiresTapes
                ? _c(
                    "v-stepper-step",
                    {
                      class: {
                        "current-step": _vm.currentStep == 2,
                        "next-step": _vm.highestStepReached < 2,
                        "previous-step": _vm.highestStepReached > 2
                      },
                      attrs: {
                        "edit-icon": "mdi-record-circle",
                        "complete-icon": "mdi-record-circle",
                        complete: "",
                        editable: _vm.highestStepReached >= 2,
                        step: "2"
                      }
                    },
                    [
                      _vm._v(" Cambio de cinta "),
                      _c("small", [
                        _vm._v(
                          " Toda la información relacionada con la entrega, recepción, cambio o desecho de las cintas "
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm.requiresTapes
                ? _c(
                    "v-stepper-content",
                    { attrs: { step: "2" } },
                    [
                      _c("Ticket-Requirement-Step-One", {
                        ref: "Step2",
                        attrs: {
                          ticketSubjectSelected:
                            _vm.requirementTicket.generalInformation.subject
                        },
                        on: {
                          nextStep: _vm.nextStep,
                          previousStep: _vm.previousStep
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-stepper-step",
                {
                  class: {
                    "current-step": _vm.currentStep == 3,
                    "next-step": _vm.highestStepReached < 3,
                    "previous-step": _vm.highestStepReached > 3
                  },
                  attrs: {
                    "edit-icon": "mdi-check-all",
                    "complete-icon": "mdi-check-all",
                    complete: "",
                    editable: _vm.highestStepReached >= 3,
                    step: "3"
                  }
                },
                [
                  _vm._v(" Resumen del ticket de Gestión de Cintas "),
                  _c("small", [
                    _vm._v(
                      " Resumen de toda la información suministrada hasta ahora "
                    )
                  ])
                ]
              ),
              _c(
                "v-stepper-content",
                { attrs: { step: "3" } },
                [
                  _c("Ticket-Requirement-Step-Two", {
                    ref: "Step3",
                    attrs: { requirementTicket: _vm.requirementTicket },
                    on: {
                      nextStep: _vm.nextStep,
                      previousStep: _vm.previousStep,
                      reset: function($event) {
                        return _vm.$router.push({ name: "tickets" })
                      },
                      sendRequirementTicket: _vm.sendRequirementTicket
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: { top: "", timeout: _vm.timeout, color: "error" },
          model: {
            value: _vm.errorLoadingContent,
            callback: function($$v) {
              _vm.errorLoadingContent = $$v
            },
            expression: "errorLoadingContent"
          }
        },
        [
          _vm._v(
            " Ocurrió un error obteniendo la información para la creación del ticket, por favor intente nuevamente "
          ),
          _c(
            "v-btn",
            {
              attrs: { color: "white", text: "" },
              on: {
                click: function($event) {
                  _vm.errorLoadingContent = false
                }
              }
            },
            [_vm._v("Cerrar")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }